/* eslint-disable react/no-danger */
import React from 'react';
import {
  arrayOf,
  bool,
  func,
  node,
  object,
  oneOfType,
  string,
} from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import { ButtonContainer } from './styles';

const Button = React.forwardRef(
  (
    {
      children,
      href,
      onClick,
      disabled,
      buttonType,
      buttonStyle,
      className,
      size,
      modalRemote,
      remote,
      newWindow,
      method,
      data,
      style,
    },
    ref
  ) => {
    const btnData = {};
    // TODO: use new DataAttributeHelper function
    Object.entries(data).forEach(([key, value]) => {
      if (key === 'remote' || key === 'method') {
        btnData['data-turbo'] = false;
      }

      btnData[`data-${key}`] = value;
    });

    if (method) {
      btnData['data-method'] = method;
    }
    if (remote) {
      btnData['data-remote'] = remote;
    }

    const modalRemoteProps = (path) => ({
      'data-action': 'modal-remote#show',
      'data-controller': 'modal-remote',
      'data-modal-remote-url': path,
    });

    const btnProps = {
      buttonStyle,
      buttonType,
      className,
      disabled,
      href,
      onClick,
      size,
      target: newWindow ? '_blank' : '_self',
      rel: 'noreferer',
      ...(modalRemote && modalRemoteProps(href)),
      ...btnData,
      style,
    };
    if (disabled) {
      btnProps.onClick = () => false;
    }

    return (
      <ButtonContainer ref={ref} {...btnProps}>
        {children}
      </ButtonContainer>
    );
  }
);

Button.defaultProps = {
  buttonStyle: 'raised',
  buttonType: 'primary',
  className: null,
  data: {},
  disabled: false,
  href: null,
  method: null,
  modalRemote: false,
  newWindow: false,
  onClick: () => {},
  remote: false,
  size: null,
  style: {},
};

Button.propTypes = {
  buttonStyle: string,
  buttonType: string,
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  data: object,
  disabled: bool,
  href: string,
  method: string,
  modalRemote: bool,
  newWindow: bool,
  onClick: func,
  remote: bool,
  size: string,
  style: object,
};

function ButtonFallback() {
  return <span />;
}

export default exportWithBoundary(Button, ButtonFallback);
